import React from "react";
import { FormSpy } from "react-final-form";
import {
  InstrumentSelectField,
  InstrumentTypeSelectField,
} from "@syos-music/instruments";
import { TextField } from "@syos-music/form";

import { Grid } from "@mui/material";

import FileField from "components/form/FileField";

function LegacyMouthpieceField({ name, uploadBasePath }) {
  return (
    <Grid container>
      {uploadBasePath && (
        <Grid item xs={12}>
          <FileField
            name={`${name}.stlFile`}
            uploadPath={uploadBasePath}
            isPublic={false}
            label="Fichier STL"
            fullWidth
          />
        </Grid>
      )}

      <Grid item xs={6}>
        <InstrumentSelectField name={`${name}.instrument`} required />
      </Grid>

      <Grid item xs={6}>
        <FormSpy subscription={{ values: true }}>
          {({ form }) => {
            const instrument = form.getFieldState(`${name}.instrument`)?.value;
            if (!instrument) return null;

            return (
              <InstrumentTypeSelectField
                instrument={instrument}
                name={`${name}.${instrument}Type`}
                required
              />
            );
          }}
        </FormSpy>
      </Grid>

      <Grid item xs={12}>
        <TextField name={`${name}.name`} required label="Nom" />
      </Grid>

      <Grid item xs={12}>
        <TextField name={`${name}.params.baffle`} required label="Plafond" />
      </Grid>
      <Grid item xs={12}>
        <TextField name={`${name}.params.chamber`} required label="Chambre" />
      </Grid>
      <Grid item xs={12}>
        <TextField name={`${name}.params.striations`} required label="Stries" />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name={`${name}.params.tipOpening`}
          required
          label="Ouverture"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name={`${name}.params.tableFacing`}
          required
          label="Longueur de la table"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name={`${name}.params.tableWidth`}
          required
          label="Largeur de la table"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField name={`${name}.params.design`} required label="Design" />
      </Grid>
      <Grid item xs={12}>
        <TextField name={`${name}.params.shank`} required label="Tenon" />
      </Grid>
      <Grid item xs={12}>
        <TextField name={`${name}.params.volume`} required label="Volume" />
      </Grid>
    </Grid>
  );
}

LegacyMouthpieceField.defaultValues = {
  params: {
    striations: "0",
    tableWidth: "Standard",
    design: "Ébonite",
    shank: "Standard",
    volume: "Standard",

    ...(process.env.NODE_ENV === "development"
      ? {
          baffle: "YOLO",
          chamber: "YOLO",
          tipOpening: "YOLO",
          tableFacing: "YOLO",
        }
      : {}),
  },
};

export default LegacyMouthpieceField;
